import DateHelper, { Weekday } from "Utility/DateHelper";

export const SEASON_PASS_CONFIG_SLUG = 'season_pass.json';
export const SEASON_PASS_BASE_PATH = 'resource/seasonpass/';
export const SEASON_PASS_UNLOCK_LEVEL = 9;
export const SEASON_PASS_PREMIUM_REMINDER = 'season_pass_premium_reminder';
export const SEASON_PASS_INTRO_INFO = 'season_pass_intro_info';
export const SEASON_PASS_NEW_SEASON_FTUX = 'season_pass_new_season_ftux';
export const SEASON_PASS_STARTS = Weekday.TUE;
export const SEASON_PASS_DURATION = DateHelper.daysToMilliseconds(14);
export const INITIAL_SEASON_PASS_DATE = DateHelper.getDateFromValue("2024-12-10T00:00:00.000Z");

export enum SeasonPassEvent {
    ProgressUpdate = 'progress_update',
}